import { HomeTemplatesItemController } from './home-templates-item.controller'

function homeTemplatesItem () {
  return {
    restrict: 'E',
    scope: {
      template: '<'
    },
    templateUrl: '/home/directives/home-templates-item/home-templates-item-directive.html?$$REVISION$$',
    controller: HomeTemplatesItemController
  }
}

export { homeTemplatesItem }
